import { setBridgeVanillaToRedux } from '../../GlobalState/extReduxBridge';
import { isSmartphoneOrTablet } from '../../pages/Play/joysticks/messages';
import { initMobileControllers } from '../../pages/Play/joysticks/joysticks';
import { isLocal, isMainnet, isTestnet } from '../../constants/envs';
import { initPaymentsBridge } from '../../services/microPayments/buyResources';
import version from '../../config/version.json';


// ---- BROWSER ----

export const browserCustomize = () => {
  // ## VERSIONING
  setupVersion();

  // ## REDUX BRIDGE between the 2 JS layers
  isLocal && console.debug('Setting up Redux bridge..');
  setBridgeVanillaToRedux();

  // ## MOBILE CONTROLLERS
  isLocal && console.debug('Setting up Mobile controllers..');
  // NOTE: PLAYTEST ONLY for now, and only on mobile
  isTestnet && isSmartphoneOrTablet && initMobileControllers();
  
  // ## LOGGING
  isLocal && console.debug('Setting up Logging..');
  if (isMainnet) {
    console.log = console.debug = () => { };
  } else {
    // const originalConsoleLog = console.log;
    // console.log = (...args) => {
    //   const url = args[0];
    //   if (!url || url.includes('PHANTOM DEBUG')) return;
    //   originalConsoleLog(...args);
    // };
  }


  // ## BRIDGE MICRO PAYMENTS
  initPaymentsBridge();
};


const setupVersion = () => {
  console.log('[version] setting up ReactUI version...', version.REACT_UI_VERSION, Date.now());
  // -- Add Wrapper Version
  if (window.version) {
    window.version.reactUI = version.REACT_UI_VERSION;
  } else {
    window.version = { reactUI: version.REACT_UI_VERSION };
  }
  // -- LocalStorage update
  const lsData = window.localStorage.getItem('version');
  if (lsData) {
    const versions = JSON.parse(lsData);
    versions.reactUI = version.REACT_UI_VERSION;
    window.localStorage.setItem('version', JSON.stringify(versions));
  } else {
    window.localStorage.setItem('version', JSON.stringify(window.version));
  }
  // -- Anti Tampering...
  // ...
};
